export const TIME_IN_MS = {
  SEC_1: 1000,
  SEC_10: 1000 * 10,
  SEC_15: 1000 * 15,
  SEC_30: 1000 * 30,
  MIN_1: 1000 * 60,
  MIN_10: 1000 * 60 * 10,
  HR_1: 1000 * 60 * 60,
};

export const TIME_IN_SEC = {
  SEC_1: 1,
  SEC_10: 10,
  SEC_30: 30,
  MIN_1: 60,
  MIN_10: 60 * 10,
  HR_1: 60 * 60,
};

export const TIME_IN_MIN = {
  MIN_1: 1,
  MIN_5: 5,
  MIN_10: 10,
  HR_1: 60,
};
